<template>
<div class="step-con">
  <div class="infor-headerBg">
    <div class="infor-header layout">
      <a href="#" class="logo"></a>
      <div class="ltxt">医学教育网在线模拟考试系统</div>
    </div>
  </div>
  <div class="infor-main layout clearfix">
    <!--信息确认-左侧-->
    <div class="infor-left clearfix" style="height: 777px;">
      <div class="seat">
        <div class="seat-tit">座位号</div>
        <div class="seat-num">1</div>
      </div>
      <div class="tsBox">
        <p>一、所有按键均可使用鼠标操作。</p>
        <p>二、考试过程中需要用到的按键：</p>
        <p>1、选择相应的答案。</p>
        <p>2、（1）进入上一题←，进入下一题→；</p>
        <p>　 （2）调出计算器；</p>
        <p>　 （3）查看帮助；</p>
        <p>　 （4）交卷；</p>
      </div>
    </div>
    <!--信息确认-左侧 end-->

    <!--信息确认-右侧-->
    <div class="infor-right clearfix">
      <div class="personal">
        <div class="photo"><img src="https://member.med66.com/medqz/resources/images/2020mokaoxitong/ex_pic_01.jpg"></div>
        <div class="txt"><em class="txt-fd">姓　　名：</em>王一</div>
        <div class="txt"><em class="txt-fd">性　　别：</em>男</div>
        <div class="txt"><em class="txt-fd">准考证号：</em>11010100216</div>
        <div class="txt"><em class="txt-fd">证件类型：</em>身份证</div>
        <div class="txt"><em class="txt-fd">证件编号：</em>220621198912020046</div>
        <div class="txt"><em class="txt-fd">所在考场：</em>北京职业卫生学校</div>
        <div class="txt"><em class="txt-fd">当前场次：</em>01</div>
        <div class="txt"><em class="txt-fd">所在试室：</em>第二试室</div>
        <div class="txt"><em class="txt-fd">所在单位：</em>北京大学人民医院</div>
      </div>
      <div class="hbox">
        <a href="javascript:void(0)" @click="gotoNext" class="btn">进入考场</a>
        <p class="ts">注：以上个人信息为虚拟内容，仅供考生参考</p>
      </div>
      <div class="notice">
        <p class="txt">考生须知</p>
        <p class="txt">1.考生进入考室后，须在《签到表》上签字，对号入座后将本人《准考证》、有效身份证明放在课桌右上角，以便核验。</p>
        <p class="txt">2.开考前15分钟，考生可按准考证号和身份证号信息登录考试系统（证件输入应注意括号和大小写），核对并确认基本信息无误后，进入考试规则和考生承诺界面，仔细阅读相关文件并确认后，等待考试开始。</p>
        <p class="txt">3.考生进入考试系统后，应注意考试界面的<em id="time">右侧</em>显示的开始时间、结束时间和剩余时间，考试过程中把控好考试时间。完成并提交答题信息前，应注意考试界面<em id="tishi">下方</em>的答题提示，确认没有未答题。</p>
        <p class="txt">4.提前结束答题的考生，可点击“完成考试”按钮。</p>
        <p class="txt">5.考试结束后，系统将自动提示“时间到，考试结束”，未完成的考生将不能继续答题。</p>
      </div>
    </div>
    <!--信息确认-右侧 end-->
  </div>
  <CommonFooter />
</div>
</template>

<script>
import {CommonFooter} from "../../components/common";

export default {
  name: "step1",
  components:{
    CommonFooter
  },
  methods:{
    gotoNext(){
      const { courseID,centerID,siteCourseID,saveBizID } = this.$route.query
      this.$router.push({
        path:'step2',
        query:{
          courseID:courseID,
          centerID:centerID,
          siteCourseID:siteCourseID,
          saveBizID:saveBizID
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
